import { render, staticRenderFns } from "./Aneel5_XMLProrrogacao.vue?vue&type=template&id=2b2801f0&"
import script from "./Aneel5_XMLProrrogacao.vue?vue&type=script&lang=js&"
export * from "./Aneel5_XMLProrrogacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports